import { configureStore } from "@reduxjs/toolkit"

import { IS_DEVELOPMENT } from "../env-management"

import { rootReducer } from "./reducer"
import { surveyListenerMiddleware } from "./slices"

const store = configureStore({
    reducer: rootReducer,
    devTools: IS_DEVELOPMENT,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // Игнорируем предупреждения для несериализуемых данных (ServicesGroup, Date)
                ignoredActions: [
                    "bookingFlow/setServiceGroups",
                    "bookingFlow/setServiceGroup",
                    "bookingFlow/setSelectedService",
                    "bookingFlow/setBookingSelectedTime",
                    "bookingFlow/setBookingSelectedDayOfMonth",
                    "bookingFlow/setBookingCurrentWeek",
                    "bookingFlow/restoreBookingState",
                ],
                ignoredPaths: [
                    "bookingFlow.serviceGroups",
                    "bookingFlow.serviceGroup",
                    "bookingFlow.selectedService",
                    "bookingFlow.booking.selectedTime",
                    "bookingFlow.booking.selectedDayOfMonth",
                    "bookingFlow.booking.currentWeek",
                ],
            },
        }).concat(surveyListenerMiddleware.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export { store }
